import cn from 'classnames';
import React, { InputHTMLAttributes, memo } from 'react';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  label?: string;
  note?: string;
  name: string;
  error?: any;
  type?: string;
  shadow?: boolean;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  touched?: any;
  handldChange?: any;
  containerClass?: string;
  variant?: 'normal' | 'solid' | 'outline' | 'base';
  required?: boolean;
}
const classes = {
  root: '',
  normal: 'form-control rounded-[7px]',
  solid: 'form-control rounded-[7px] bg-lightGrey',
  outline:
    'border border-solid border-blue-placeholder focus:border-blue-cta focus:border-[3px]',
  base: 'h-11 bg-blue-10 border border-blue-450 text-sharpBlue placeholder:text-sharpBlue font-normal !text-base',
  error: 'border border-red',
  shadow: 'focus:shadow',
};
const InputField = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      label,
      touched,
      note,
      name,
      error,
      variant = 'normal',
      shadow = false,
      type = 'text',
      inputClassName,
      labelClassName,
      containerClass,
      rightIcon,
      leftIcon,
      handldChange,
      required = false,
      ...rest
    },
    ref
  ) => {
    const rootClassName = cn(
      classes.root,
      {
        [classes.normal]: variant === 'normal',
        [classes.solid]: variant === 'solid',
        [classes.outline]: variant === 'outline',
        [classes.base]: variant === 'base',
      },
      {
        [classes.shadow]: shadow,
      },
      inputClassName
    );
    const _labelClassName = 'mb-2 text-sm font-normal  inline-block';
    return (
      <div className={cn('form-group', className)}>
        {label && (
          <label htmlFor={name} className={cn(_labelClassName, labelClassName)}>
            {label} {required && <span style={{ color: "red" }}> *</span>}
          </label>
        )}
        <div className={cn('d-flex gap-2', containerClass)}>
          {leftIcon && <div className="position-absolute left-3">{leftIcon}</div>}
          <input
            id={name}
            name={name}
            type={type}
            ref={ref}
            className={`${rootClassName} no-blue-focus ${leftIcon ? '!pl-12' : ''} ${
              error && touched ? classes.error : ''
            }`}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            aria-invalid={error ? 'true' : 'false'}
            onChange={handldChange}
            {...rest}
          />
          {rightIcon && <div className="position-absolute right-3">{rightIcon}</div>}
        </div>
        {note && <p className="mt-2 text-xs text-body">{note}</p>}
        {/* {touched && error && (
          <p className={`my-2 text-xs text-start text-red`}>{error}</p>
        )} */}
      </div>
    );
  }
);

export default memo(InputField);


// Add style override for no-blue-focus
if (typeof window !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `.no-blue-focus:focus { border-color: #d1d5db !important; box-shadow: none !important; }`;
  document.head.appendChild(style);
}